import { Component, OnInit } from '@angular/core'

import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { filter, startWith, switchMap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { activitySelectors } from '../../activity/activity.selectors'
import { UntilDestroy } from '@ngneat/until-destroy'
import { Course } from '../course'
import { courseSelectors } from '../course.selectors'

@UntilDestroy()
@Component({
  selector: 'course-activities-main-tab',
  templateUrl: './course-activities-tab.component.html',
  styleUrls: ['./course-activities-tab.component.scss']
})
export class CourseActivitiesMainTabComponent implements OnInit {
  public course$: Observable<Course>

  public isLoading$ = this.store
    .select(activitySelectors.selectIsLoading)
    .pipe(startWith(false))

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.course$ = this.store.select(courseSelectors.selectIdRouteParam).pipe(
      filter((courseId) => Boolean(courseId)),
      switchMap((courseId) =>
        this.store.select(courseSelectors.selectById, courseId)
      ),
      filter((course) => Boolean(course))
    )
  }
}
